import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import PasswordForm from "./PasswordForm";
import SecurityQuestionsForm from "./SecurityQuestionsForm";
import Divider from "components/common/Divider";

export default function SecuritySettings() {
  const [activeSection, setActiveSection] = useState(null);
  return (
    <>
      {activeSection === null && (
        <Row>
          <Col>
            <h6 className="mb-0 fw-semibold text-sm">Password Modification</h6>
            <p className="mb-3 text-xxs mt-2">
              Update your password regularly to enhance account security. Ensure
              your new password is strong and unique.
            </p>

            <div className="mb-3 text-info text-xxs fw-semibold">
              <FontAwesomeIcon icon="info-circle" className="me-2" />
              Your password was last updated on 07/08/22
            </div>

            <Button
              variant="light"
              className="border text-sm"
              onClick={() => setActiveSection("password")}
            >
              Change Password
            </Button>
          </Col>
          <Divider className="my-3"/>
          <Col>
            <h6 className="mb-0 fw-semibold text-sm">Security Questions</h6>

            <p className="mb-3 text-xxs mt-2">
              Add security questions to provide an additional layer of
              protection for your account. These questions help verify your
              identity if you ever need to reset your password.
            </p>

            <div className="mb-3 text-info text-xxs fw-semibold">
              <FontAwesomeIcon icon="shield-alt" className="me-2" />
              No security questions have been set up yet
            </div>

            <Button
              variant="light"
              className="border text-sm"
              onClick={() => setActiveSection("securityQuestions")}
            >
              Add Security Questions
            </Button>
          </Col>
        </Row>
      )}

      {activeSection === "password" && (
        <PasswordForm onBack={() => setActiveSection(null)} />
      )}

      {activeSection === "securityQuestions" && (
        <SecurityQuestionsForm onBack={() => setActiveSection(null)} />
      )}
    </>
  );
}
